<template>
<v-dialog v-model="show" max-width="800">
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on" :count="sample_notes.length.toString()"></slot>
  </template>
  <v-card>
    <CardTitle :title="`Notes`"></CardTitle>
    <v-card-text>
      <v-simple-table>
        <tbody>
          <tr v-for="note in sample_notes.filter(item => item.note_type.name.toLowerCase() === 'billing')">
            <td>{{note.note_type.name}}</td>
            <td>{{note.note}}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
export default {
    name: "SampleNotes",
    components: {},
    data: () => ({
      show: false
    }),
  props:{
      sample_notes: {
        required: true,
      }
  },
    methods: {}
}
</script>

<style scoped>

</style>
